import './EnableGold.sass';

import React, { FC, useCallback } from 'react';
import { Button, Header, ScrollView } from '$uikit';
import { IcLinkOld28, IcUserPlus28 } from '$assets';
import { useDispatch, useSelector } from 'react-redux';
import { inviteActions, inviteSelector } from '$store/invite';
import { useTranslator } from '$hooks';
import { GOLD_PROGRAM_PAGE } from '$core/Invite/Invite';
import { _confirm } from '$utils';

export const EnableGold: FC = () => {
  const dispatch = useDispatch();
  const { isGold } = useSelector(inviteSelector);
  const t = useTranslator();

  const handleEnableGold = () => {
    _confirm(t('enable_gold_confirm'), () => dispatch(inviteActions.enableGold()));
  };

  if (isGold) {
    return null;
  }

  return (
    <>
      <Header showCloseButton />
      <ScrollView className="EnableGold">
        <div className="EnableGold__content">
          <div className="EnableGold__icon">
            <IcUserPlus28 />
          </div>
          <div className="EnableGold__title">{t('enable_gold_title')}</div>
          <div className="EnableGold__description">{t('enable_gold_caption')}</div>
          <div className="EnableGold__buttons">
            <a href={GOLD_PROGRAM_PAGE} target="_blank" rel="noreferrer">
              <Button mode="secondary" iconRight={<IcLinkOld28 />}>
                {t('enable_gold_button_detailed_info')}
              </Button>
            </a>
            <Button onClick={handleEnableGold}>{t('enable_gold_button_accept')}</Button>
          </div>
        </div>
      </ScrollView>
    </>
  );
};
